import { render } from "./BusinessCompanyDetail.vue?vue&type=template&id=55de7666"
import script from "./BusinessCompanyDetail.vue?vue&type=script&lang=js"
export * from "./BusinessCompanyDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__